/*
export function someMutation (state) {
}
*/
export const setEditUserDialog = (state, editUserDialog) => {
  state.editUserDialog = editUserDialog
}
export const setCurrentClassroom = (state, data) => {
  state.currentClassroom = data
}
